import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function PrivateRoute({ children, hasCookie, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        hasCookie ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/unauthorized',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
